import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';

import { CANCEL_SUBSCRIPTION } from 'graphql/subs';
import useSubscription from 'hooks/useSubscription';
import { formatTimestamp } from 'utils/dates';
import { Loading, Spacing } from 'components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogActions: {
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
      },
    },
  }),
);

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SubscriptionCancelDialog: React.FC<Props> = (props) => {
  const { isOpen, onClose } = props;
  const classes = useStyles();
  const { subscription } = useSubscription();
  const renewalDate = formatTimestamp()(subscription!.currentPeriodEnd);
  const [cancelSubscription, { loading }] = useMutation(CANCEL_SUBSCRIPTION);

  const cancel = async () => {
    await cancelSubscription();
    onClose();
  };

  const renderBody = () => (
    <>
      <Grid item>
        <Typography variant="body2">
          Your subscription will be cancelled at the end of you billing period on{' '}
          <b>{renewalDate}</b>. You can change your mind any time before this date.
        </Typography>
      </Grid>
      <Spacing height="32px" />
    </>
  );

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isOpen}
      onClose={onClose}
      aria-labelledby="cancel-dialog-title"
    >
      <DialogTitle id="cancel-dialog-title">Cancel Subscription?</DialogTitle>
      <DialogContent>{renderBody()}</DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button color="primary" onClick={() => onClose()}>
          Nevermind
        </Button>
        <Button color="primary" disabled={loading} onClick={() => cancel()}>
          {loading && <Loading size={20} style={{ marginTop: '-10px' }} />}
          {!loading && 'Cancel Subscription'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionCancelDialog;
